import { render, staticRenderFns } from "./CCWaterMark.vue?vue&type=template&id=6979b3dd"
import script from "./CCWaterMark.vue?vue&type=script&lang=js"
export * from "./CCWaterMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports